var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"inline-icon-text"},[_c('Icon',{attrs:{"name":_vm.icon,"size":"small","color":"var(--secondary)"}}),_vm._v(" "+_vm._s(_vm.title)+" ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }